// extracted by mini-css-extract-plugin
export default {"wrap":"formWrapResponse_wrap__FhPKJ","show":"formWrapResponse_show__4Dwir","closeButton":"formWrapResponse_closeButton__DOr1h","closeSvg":"formWrapResponse_closeSvg__VrssP"};